interface BasicComponent {
  props?: any;
  data?: Function;
  mounted?: Function;
  created?: Function;
  methods?: {};
  computed?: {};
  watch?: {};
  [key: string]: any;
}

class BasicComponent {
  _component!: BasicComponent;
  _props: any;
  _implementKeys: string[] = [];

  constructor(component: any = {}) {
    this._component = component;
  }

  _setAny(key: string) {
    this._component[key] = !this._component[key]
      ? this[`_${key}`]
      : { ...this[`_${key}`], ...this._component[key] };
  }

  _setImplementKeys() {
    for(let item of this._implementKeys) {
      this._setAny(item);
    }
  }

  _setData() {
    let cData = {}
    if (typeof this._component.data === 'function') {
      cData = this._component.data();
    }
    this._component.data = () => ({
      ...this._data,
      ...cData
    });
  }

  addImplementKeys(value: string | string[]) {
    const type = typeof value;
    if (type === 'string') {
      this._implementKeys.push(value as string);
    } else if (type === 'object') {
      for(let v of value) {
        this._implementKeys.push(v);
      }
    }
  }

  get comp() {
    this._setData();
    this._setImplementKeys();
    return this._component;
  }

  static componentFromStepName(stepName: string) {
    return stepName[0].toUpperCase() + stepName.slice(1) + 'View';
  }
}

export default BasicComponent;
